import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EsignEnvelopeType extends Enum {
  static INTERIM_DISTRIBUTION_RELEASE = {
    key: 'interim_distribution_release',
    get value() {
      return Lang.t('esign.interim-distribution-release');
    },
    color: '' // TODO: needs a unique color
  };

  static DISTRIBUTION_PLAN = {
    key: 'distribution_plan',
    get value() {
      return Lang.t('esign.distribution-plan');
    },
    color: '' // TODO: needs a unique color
  };

  static INTERIM_DISTRIBUTION = {
    key: 'interim_distribution_plan',
    get value() {
      return Lang.t('esign.interim-distribution');
    },
    color: '' // TODO: needs a unique color
  };

  static NOTIFY = {
    key: 'notify',
    get value() {
      return Lang.t('esign.notify');
    },
    color: '#46b6ea'
  };

  static PROBATE = {
    key: 'probate',
    get value() {
      return Lang.t('billing.probate');
    },
    color: '#db64d4'
  };

  static TAX = {
    key: 'tax',
    get value() {
      return Lang.t('document.tax');
    },
    color: '#db64d4'
  };

  static NOTIFY_BENEFICIARIES = {
    key: 'notify_beneficiaries',
    get value() {
      return Lang.t('esign.notify-beneficiaries');
    },
    color: '' //
  };

  static NOTIFY_CREDITORS = {
    key: 'notify_creditors',
    get value() {
      return Lang.t('esign.notify-creditors');
    },
    color: '' //
  };

  static FINALIZE_INVENTORY_VALUE = {
    key: 'finalize_inventory_value',
    get value() {
      return Lang.t('esign.finalize_inventory');
    },
    color: '' //
  };

  static LIMITED_SCOPE_REPRESENTATION_AGREEMENT = {
    key: 'limited_scope_representation_agreement',
    get value() {
      return Lang.t('guidancestep.limited-scope-representation-agreement');
    },
    color: '' //
  };
}
